var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDifficultyNormalFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.9999C2 13.5522 1.55228 13.9999 1 13.9999C0.447715 13.9999 0 13.5522 0 12.9999V0.999939C2.66667 -0.333394 5.66667 -0.333394 7 0.999939C8.33333 2.33327 11.3333 2.33327 14 0.999939V9.99994C11.3333 11.3333 8.33333 11.3333 7 9.99994C6.02393 9.02387 3.6906 8.76233 2 9.21533V12.9999Z",
    fill: "#FF9045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDifficultyNormalFlag);
export default __webpack_public_path__ + "static/media/question-difficulty-normal-flag.f5ccda2c537b92b0b1bba5f68e553d4f.svg";
export { ForwardRef as ReactComponent };